/**
 * Tooltip
 * Basic tooltip pop-over.
 */
import React from 'react';
// import Popper from 'popper.js';

const withPopper = (Component) => {
  class EnhancedComponent extends React.Component {
    constructor() {
      super();

      this.state = {
        pos: {
          top: null,
          left: null,
        },
        placement: null,
      };
    }
    componentDidMount() {
      // this.init();
    }
    componentWillUnmount() {
      // this.popper.destroy();
    }
    applyReactStyle = (d) => {
      this.setState({
        pos: {
          top: d.popper.top,
          bottom: d.popper.bottom,
          left: d.popper.left,
        },
        placement: d.placement,
      });
    }
    init() {
      this.popper = new Popper(this.wrapper, this.tooltip, {
        modifiers: {
          applyStyle: { enabled: false },
          applyReactStyle: {
            enabled: true,
            fn: this.applyReactStyle,
            order: 800,
          },
          onUpdate: this.applyReactStyle,
        },
      });
    }
    render() {
      return (
        <Component
          pos={this.state.pos}
          placement={this.state.placement}
          // popperRef={c => this.tooltip = c}
          // wrapperRef={c => this.wrapper = c}
          {...this.props}
        />
      );
    }
  }

  return EnhancedComponent;
};

export default withPopper;
